import { Capacitor } from '@capacitor/core'
import { Device } from '@capacitor/device'

export const getInfo = async (): Promise<unknown> => {
  return { ...(await Device.getInfo()), ...(await Device.getId()) }
}

export const getId = async (): Promise<string> => {
  return (await Device.getId()).identifier
}

export const getPlatform = (): string => Capacitor.getPlatform()

export const isWeb = getPlatform() == 'web'
